import { APICore } from "./apiCore";
import axios from "axios";
import config from "../../config";

const api = new APICore();

// account
function login(params) {
  const baseUrl = "/auth/login";
  const payload = {
    email: params.username, // Map username to email for Go Fiber API
    password: params.password
  };
  const baseURL = config.API_URL;
  
  console.log("Login API call - URL:", baseUrl);
  console.log("Login API call - Payload:", payload);
  
  // Try using a fresh axios instance without interceptors
  const freshAxios = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json'
    }
  });
  
  console.log("Making fresh axios call...");
  return freshAxios.post(baseUrl, payload)
    .then(response => {
      console.log("Fresh axios success:", response);
      return response;
    })
    .catch(error => {
      console.error("Fresh axios error:", error);
      throw error;
    });
}

function logout() {
  // Since JWT is stateless, logout is handled client-side
  // Just return a resolved promise to maintain consistency
  return Promise.resolve({ data: { message: "Logged out successfully" } });
}

function signup(params) {
  const baseUrl = "/auth/register";
  return api.create(`${baseUrl}`, {
    name: params.fullname,
    email: params.email,
    password: params.password
  });
}

function forgotPassword(params) {
  const baseUrl = "/auth/forgot-password";
  return api.create(`${baseUrl}`, params);
}

// Get user profile
function getProfile() {
  const baseUrl = "/profile";
  return api.get(`${baseUrl}`);
}

// Refresh token
function refreshToken(refreshToken) {
  const baseUrl = "/auth/refresh";
  return api.create(`${baseUrl}`, {
    refresh_token: refreshToken
  });
}

export { login, logout, signup, forgotPassword, getProfile, refreshToken };
